import { render } from "./FindAMatch.vue?vue&type=template&id=10e72e9a&ts=true"
import script from "./FindAMatch?vue&type=script&lang=ts&external"
export * from "./FindAMatch?vue&type=script&lang=ts&external"

import "./FindAMatch.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__